import { Injectable } from '@angular/core';
import { PartialStateUpdater, patchState, signalState } from '@ngrx/signals';

interface State {
  activeTaskId: string | null;
  activeTaskGroupId: string | null;
}

const defaultState: State = {
  activeTaskId: null,
  activeTaskGroupId: null,
};

@Injectable({
  providedIn: 'root',
})
export class UrlParamsState {
  private readonly urlParamsState = signalState<State>(defaultState);

  public readonly activeTaskId = this.urlParamsState.activeTaskId;
  public readonly activeTaskGroupId = this.urlParamsState.activeTaskGroupId;

  setActiveTaskId(activeTaskId: string | null) {
    patchState(this.urlParamsState, this.activeTaskIdSetter(activeTaskId));
  }

  setActiveTaskGroupId(activeTaskGroupId: string | null) {
    patchState(
      this.urlParamsState,
      this.activeTaskGroupIdSetter(activeTaskGroupId)
    );
  }

  private activeTaskIdSetter(
    activeTaskId: string | null
  ): PartialStateUpdater<{ activeTaskId: string | null }> {
    return () => ({ activeTaskId });
  }

  private activeTaskGroupIdSetter(
    activeTaskGroupId: string | null
  ): PartialStateUpdater<{ activeTaskGroupId: string | null }> {
    return () => ({ activeTaskGroupId });
  }
}
